import { Divider } from '@byecode/ui'
import { Group4ByecodeUi } from '@lighthouse/shared'
import { find } from 'rambda'
import React, { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import { BaseDataConfigurator } from '../BaseDataConfigurator'
import { DefaultDataSource } from '../DataSource'
import type { ChartFormSlice } from '../formSlice'
import { IndicatorDesign } from '../IndicatorDesign'
import { OperatorConfigurator } from '../OperatorConfigurator'
import { SingleIndicatorConfigurator } from '../SingleIndicatorConfigurator'

interface IndicatorCardConfiguratorProps {}

export const IndicatorCardConfigurator: React.FC<IndicatorCardConfiguratorProps> = () => {
    const { control } = useFormContext<ChartFormSlice>()
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const dataSourceList = useDataSourceList(appId, envId)

    const pointer = useWatch({ control, name: 'pointer' })

    const dataSource = useMemo(
        () => find(item => item.appId === appId && item.id === pointer, dataSourceList),
        [appId, dataSourceList, pointer]
    )

    // 筛选器blocks
    // const filterBlocks = useMemo(() => {
    //     if (!pageBlocks) {
    //         return []
    //     }
    //     return filterBlock(pageBlocks, block => block.type === 'filter') as FilterBlockAbstract[]
    // }, [pageBlocks])

    return (
        <>
            <DefaultDataSource />
            {dataSource && (
                <>
                    <Divider color="var(--color-gray-200)" />
                    <SingleIndicatorConfigurator dataSource={dataSource} />
                    <Divider color="var(--color-gray-200)" />
                    <IndicatorDesign />
                    <Divider color="var(--color-gray-200)" />
                    <Group4ByecodeUi label="数据设置">
                        <BaseDataConfigurator dataSource={dataSource} dataSourceList={dataSourceList} />
                    </Group4ByecodeUi>
                    <OperatorConfigurator />
                </>
            )}
        </>
    )
}
